import { fork } from 'redux-saga/effects';

import { saga as analyticsSaga } from './analytics';
import { saga as commonSaga } from './common';
import { saga as copySaga } from './copy';
import { saga as copyNoticeSaga } from './copy.notice';
import { saga as navigationSaga } from './navigation';
import { saga as printSaga } from './print';
import { saga as socialSaga } from './social';

export function* saga() {
    yield fork(commonSaga);
    yield fork(socialSaga);
    yield fork(printSaga);
    yield fork(navigationSaga);
    yield fork(analyticsSaga);
    yield fork(copySaga);
    yield fork(copyNoticeSaga);
}
